import { APPLICATION_ROUTES } from '@philips-emr/hpms-provider-accreditation-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export function setupAccreditation(): void {

  applicationModuleRegistry.register({
    entry: 'accreditation',
    id: 'accreditation',
    name: 'pa.accreditation',
    route: APPLICATION_ROUTES.PROVIDER_ACCREDITATION,
    order: 1,
  });
}
